// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"menu_menuItem__2WtVp"};